import axios from "axios";

export default {
    
    baseUrl: process.env.VUE_APP_TIM_URL,
    
    parsePartnumber (partnumber, lang, apiKey) {
        return axios.get(`${this.baseUrl}/Product/SPL/SM_Modal/Parse?partnumber=${partnumber}&lang=${lang}`, {
            headers: {
                "Ocp-Apim-Subscription-Key": apiKey
            }
        })
        .then(response => {
            return response;
        })
        .catch(function (error) {
            return error.response;
        })
    },

}